/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a permission for an access role for an employee
 * @export
 * @interface EmployeeAccessRolesPermission
 */
export interface EmployeeAccessRolesPermission {
    /**
     * 
     * @type {string}
     * @memberof EmployeeAccessRolesPermission
     */
    name: EmployeeAccessRolesPermissionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof EmployeeAccessRolesPermission
     */
    scope: EmployeeAccessRolesPermissionScopeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof EmployeeAccessRolesPermission
     */
    employeeIds: Array<number>;
}

/**
* @export
* @enum {string}
*/
export enum EmployeeAccessRolesPermissionNameEnum {
    ManageBilling = 'ManageBilling',
    ManageClockInPortals = 'ManageClockInPortals',
    ManageCompanyOnboarding = 'ManageCompanyOnboarding',
    ManageDocuments = 'ManageDocuments',
    ManageEmployeeClocking = 'ManageEmployeeClocking',
    ManageEmployeePay = 'ManageEmployeePay',
    ManageIntegrations = 'ManageIntegrations',
    ManageJobRoles = 'ManageJobRoles',
    ManageLeave = 'ManageLeave',
    ManageLocations = 'ManageLocations',
    ManagePayPeriods = 'ManagePayPeriods',
    ManageProtectedSettings = 'ManageProtectedSettings',
    ManageSchedules = 'ManageSchedules',
    ManageSettings = 'ManageSettings',
    ManageShifts = 'ManageShifts',
    ManageTeam = 'ManageTeam',
    ManageTeamPermissions = 'ManageTeamPermissions',
    ManageTimesheets = 'ManageTimesheets',
    SendEmployeeMessage = 'SendEmployeeMessage',
    SetupClockInPortals = 'SetupClockInPortals',
    ViewDigiticketsEnhancedIntegrationData = 'ViewDigiticketsEnhancedIntegrationData',
    ViewDigiticketsIntegrationData = 'ViewDigiticketsIntegrationData',
    ViewEmployeeCosts = 'ViewEmployeeCosts',
    ViewIcrTouchIntegrationData = 'ViewIcrTouchIntegrationData',
    ViewLabourCosts = 'ViewLabourCosts'
}
/**
* @export
* @enum {string}
*/
export enum EmployeeAccessRolesPermissionScopeEnum {
    None = 'None',
    All = 'All',
    LineManagees = 'LineManagees',
    Custom = 'Custom'
}


/**
 * Check if a given object implements the EmployeeAccessRolesPermission interface.
 */
export function instanceOfEmployeeAccessRolesPermission(value: object): value is EmployeeAccessRolesPermission {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (!('employeeIds' in value) || value['employeeIds'] === undefined) return false;
    return true;
}

export function EmployeeAccessRolesPermissionFromJSON(json: any): EmployeeAccessRolesPermission {
    return EmployeeAccessRolesPermissionFromJSONTyped(json, false);
}

export function EmployeeAccessRolesPermissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeAccessRolesPermission {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'scope': json['scope'],
        'employeeIds': json['employeeIds'],
    };
}

  export function EmployeeAccessRolesPermissionToJSON(json: any): EmployeeAccessRolesPermission {
      return EmployeeAccessRolesPermissionToJSONTyped(json, false);
  }

  export function EmployeeAccessRolesPermissionToJSONTyped(value?: EmployeeAccessRolesPermission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'scope': value['scope'],
        'employeeIds': value['employeeIds'],
    };
}

